module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1n4n8n-2fcfff4bc9d606f5bfa6bce560be61b8.svg";